import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetQuizathonParticipants } from "../../../services/quizathon";
import {
  getParticipantsFailure,
  getParticipantsStart,
  getParticipantsSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getQuizathonParticipants({ payload }) {
  const response = yield call(httpGetQuizathonParticipants, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getParticipantsSuccess(raw));
  } else {
    yield put(getParticipantsFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetQuizathonParticipants() {
  yield takeLatest(getParticipantsStart.type, getQuizathonParticipants);
}
